import IOApi from '@/api/IOApi'
import { IOBudgetModel } from '@/models/IOBudget'
import { MenuModel } from '@/models/Menu'

export class InsertionOrderRepository {
  static async getMenus(id) {
    const result = await IOApi.fetchMenuList(id, {
      isIncludeDeleted: false,
      page_size: 200,
    })
    return result.items.map(menu => new MenuModel(menu))
  }

  static async getBudgets(id) {
    const result = await IOApi.fetchIOBudgetList({ IOId: id })
    return result.items.map(budget => new IOBudgetModel(budget))
  }
}
